import React from "react";
import styled from "styled-components";

export default styled.div`
    position: relative;
    height: calc(100vh - 120px);
`;
